/**
 * 组件信息
 */
export const info = {
  name: 'xy-progress', // 组件名
  type: 'component-base', // 组件类型
  label: '进度条', // 组件label
  icon: 'icon-xy-progress', // 组件图标
  defaultWidth: 600, // 组件默认宽度
  defaultHeight: 20 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  // 当前进度值
  value: { type: Number, default: 50 },
  // 最大进度值
  maxValue: { type: Number, default: 100 },
  // 进度条圆角
  borderRadius: { type: Number, default: 10 },
  // 背景颜色
  lineBackgroundColor: { type: String, default: '#EBEEF5' },
  // 进度颜色
  lineColor: { type: String, default: '#409EFF' },
  // 背景图
  lineBackgroundSrc: { type: String, default: '' },
  // 进度背景图
  lineSrc: { type: String, default: '' },
  // 节点图片
  stepSrc: { type: String, default: '' },
  // 节点宽/高
  stepSize: { type: Number, default: 60 },
  // 节点顶部距离
  stepTop: { type: Number, default: -20 }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-input-number', // 表单组件
    label: '当前进度值', // 表单名称
    propKey: 'value', // 表单model字段名称
    isActivityData: true // 是否为动态数据
  },
  {
    type: 'xy-form-input-number', // 表单组件
    label: '最大进度值', // 表单名称
    propKey: 'maxValue', // 表单model字段名称
    isActivityData: true // 是否为动态数据
  },
  {
    type: 'xy-form-input-number', // 表单组件
    label: '进度条圆角', // 表单名称
    propKey: 'borderRadius' // 表单model字段名称
  },
  {
    type: 'xy-form-color-picker', // 表单组件
    label: '背景色', // 表单名称
    propKey: 'lineBackgroundColor' // 表单model字段名称
  },
  {
    type: 'xy-form-color-picker', // 表单组件
    label: '进度背景色', // 表单名称
    propKey: 'lineColor' // 表单model字段名称
  },
  {
    type: 'xy-form-upload-image', // 表单组件
    label: '背景图', // 表单名称
    propKey: 'lineBackgroundSrc' // 表单model字段名称
  },
  {
    type: 'xy-form-upload-image', // 表单组件
    label: '进度背景图', // 表单名称
    propKey: 'lineSrc' // 表单model字段名称
  },
  {
    type: 'xy-form-upload-image', // 表单组件
    label: '节点图片', // 表单名称
    propKey: 'stepSrc' // 表单model字段名称
  },
  {
    type: 'xy-form-input-number', // 表单组件
    label: '节点宽/高', // 表单名称
    propKey: 'stepSize' // 表单model字段名称
  },
  {
    type: 'xy-form-input-number', // 表单组件
    label: '节点顶部距离', // 表单名称
    propKey: 'stepTop', // 表单model字段名称
    min: -9999
  }
]
